'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import { AlertDialog } from '@workspace/ui/components/custom/alert-dialog';
interface CardActivationConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  isLoading: boolean;
}

export function CardActivationConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  isLoading,
}: CardActivationConfirmDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={onOpenChange}
      variant="info"
      title="Activate your card?"
      description="Activate your card to start using it. Please ensure you've received it before proceeding."
    >
      <Button
        variant="primary"
        className="w-full"
        onClick={onConfirm}
        isLoading={isLoading}
        loadingText={'Activating'}
      >
        Activate
      </Button>
      <Button variant="destructive" className="w-full" onClick={() => onOpenChange(false)}>
        Cancel
      </Button>
    </AlertDialog>
  );
}
